import React from 'react'
import { BreadcrumbView } from '../../../../../../context/breadcrumb.context'
import { useParamsInt } from '../../../../../../shared/hooks/location'
import { Menu, MenuAdd, MenuRemove } from '../../../../../../shared/menu/menu'
import { CardFullHeightScrollY } from '../../../../../../shared/card/card-full-height-scroll-y'
import { useApiListNodeUser } from '../../../../../../api-new/state/content'
import { IconContent } from '../../../../../../shared/icon/icon'
import { useModalActionID } from '../../../../../../shared/component/modal-dialog'
import { PermissionUserNodeModal } from '../../../../../../shared/permission-modal/permission-user-node-modal'
import { useRoleOrgNodeUser } from '../../../../../../role/hook/role-org'
import { TableAgClient } from '../../../../../../shared/table-builder/table-ag-client'
import { ColumnText, ColumnMenu } from '../../../../../../shared/table-builder/table-columns'

export const UserListContent = () => {
  const { userID } = useParamsInt()

  const apiListNodeUser = useApiListNodeUser()

  const roleOrgNodeUser = useRoleOrgNodeUser()

  const [target, show, hide] = useModalActionID()

  const handleReady = async () => await apiListNodeUser.get(`${userID}/user`)
  const handleDestroyed = () => apiListNodeUser.init()

  const handleAddShow = () => show()
  const handleClose = () => hide()

  const handleClosed = async () => apiListNodeUser.get(`${userID}/user`)

  const handleDelete = async item => {
    await apiListNodeUser.delete(`${item.nodeID}/${item.userID}`)
    await apiListNodeUser.get(`${userID}/user`)
  }

  //   const handleDeleteAll = async () => {
  //     await apiListNodeUser.delete(`user/${userID}`)
  //     await apiListNodeUser.get(`${userID}/user`)
  //   }

  const HeaderMenu = () =>
    <Menu>
      <MenuAdd text="add content" onClick={handleAddShow} show={roleOrgNodeUser.accessCreate} />
      {/* <MenuRemove text="delete all" onClick={handleDeleteAll} show={roleOrgNodeUser.accessDelete} /> */}
    </Menu>

  return (
    <React.Fragment>
      <PermissionUserNodeModal
        target={target}
        userID={userID}
        allowAdd={roleOrgNodeUser.accessCreate}
        allowDelete={roleOrgNodeUser.accessDelete}
        onClose={handleClose}
        onClosed={handleClosed}
      />
      <BreadcrumbView Icon={IconContent} text="Content">
        <CardFullHeightScrollY title="user content" HeaderMenu={HeaderMenu}>
          <TableAgClient apiList={apiListNodeUser} hideFloatingFilter onReady={handleReady} onDestoryed={handleDestroyed}>
            <ColumnText field="nodeName" header="Name" />
            <ColumnMenu
              menu={row =>
                <Menu small>
                  <MenuRemove onClick={() => handleDelete(row)} show={roleOrgNodeUser.accessDelete} />
                </Menu>}
            />
          </TableAgClient>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
